import { render, staticRenderFns } from "./TextHTMLAttachmentListItem.vue?vue&type=template&id=ffc677e0&scoped=true"
import script from "./TextHTMLAttachmentListItem.vue?vue&type=script&lang=ts"
export * from "./TextHTMLAttachmentListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc677e0",
  null
  
)

export default component.exports